var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMerge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-3 -3 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.00061H10.7778",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4443 6.33379L10.7777 9.00045L13.4443 11.6671",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.99939L7.22222 8.99939",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55566 11.6662L7.22233 8.99955L4.55566 6.33288",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.22222V1H7.22222",
    strokeWidth: 1.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.7778L17 17L10.7778 17",
    strokeWidth: 1.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.22222V1H10.7778",
    strokeWidth: 1.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.7778L1 17L7.22222 17",
    strokeWidth: 1.4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.8cf902cf.svg";
export { ForwardRef as ReactComponent };